import { IIssue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getStatusCrud } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/cruds'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Dropdown } from 'core-components/library/dropdown'
import { Input } from 'core-components/library/inputs'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

import styles from './Issues.module.scss'

interface IProps {
  onChange: (field: string, index: number) => (value: string) => void
}

export const getIssueColumns = ({ onChange }: IProps): IColumn<IIssue>[] => {
  const statusCrud = getStatusCrud()
  return [
    {
      title: getFormedEltTranslation('issue-table-issue'),
      field: 'Issue',
      width: 380,
      renderComponent: ({ value, index }) => (
        <Input
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('Issue', index)}
        />
      ),
    },
    {
      title: getFormedEltTranslation('issue-table-hp-response'),
      field: 'HpResponse',
      width: 380,
      renderComponent: ({ value, index }) => (
        <Input
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('HpResponse', index)}
        />
      ),
    },
    {
      title: getFormedEltTranslation('issue-table-status'),
      field: 'Status',
      width: 100,
      renderComponent: ({ value, index }) => (
        <Dropdown
          classes={{
            controlClasses: {
              root: styles.input,
            },
          }}
          caption={'label'}
          source={statusCrud}
          value={value || ''}
          onChange={onChange('Status', index)}
        />
      ),
    },
  ]
}
